import { Page } from '@/core/architecture'

import { PasswordResetSendTemplate } from './template'
import { useViewModel } from './viewModel'

export const PasswordResetSend: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <PasswordResetSendTemplate
      state={state}
      onSubmitPasswordResetSend={actions.passwordResetSend}
    />
  )
}
